import React from 'react';

const MonthsAccountsPage = () => {
  return <div>준비중입니다.</div>;
};

export default MonthsAccountsPage;
